import Field from "./Field";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "@/components/ui/select";
import { INTERVIEW_STAGES } from "@/data/slate";

const OpportunitySection = ({ form, onChange }) => (
    <section className="space-y-6">
        <h2 className="font-serif text-2xl font-medium tracking-tight">The opportunity</h2>
        <div className="grid gap-6 md:grid-cols-2">
            <Field
                id="target_role"
                label="Target role title"
                value={form.target_role}
                onChange={(v) => onChange("target_role", v)}
                testId="field-target-role"
                placeholder="VP, Technology Product Management"
                required
            />
            <Field
                id="target_company"
                label="Target company (optional)"
                value={form.target_company}
                onChange={(v) => onChange("target_company", v)}
                testId="field-target-company"
                placeholder="Kept private. Anonymized in any marketing."
            />
        </div>

        <div className="space-y-2">
            <Label className="text-xs uppercase tracking-[0.2em] text-muted-foreground">
                Where you are in the process
            </Label>
            <Select
                value={form.interview_stage}
                onValueChange={(v) => onChange("interview_stage", v)}
            >
                <SelectTrigger
                    data-testid="field-interview-stage"
                    className="rounded-sm border-border bg-card font-sans"
                >
                    <SelectValue placeholder="Select a stage" />
                </SelectTrigger>
                <SelectContent>
                    {INTERVIEW_STAGES.map((s) => (
                        <SelectItem key={s.value} value={s.value}>
                            {s.label}
                        </SelectItem>
                    ))}
                </SelectContent>
            </Select>
        </div>

        <Field
            id="jd_link"
            label="Job description link (optional)"
            value={form.jd_link}
            onChange={(v) => onChange("jd_link", v)}
            testId="field-jd-link"
            placeholder="https://..."
        />

        <div className="space-y-2">
            <Label htmlFor="jd_text" className="text-xs uppercase tracking-[0.2em] text-muted-foreground">
                Or paste the JD here (optional)
            </Label>
            <Textarea
                id="jd_text"
                data-testid="field-jd-text"
                value={form.jd_text}
                onChange={(e) => onChange("jd_text", e.target.value)}
                rows={5}
                className="rounded-sm border-border bg-card font-sans"
                placeholder="Paste the full job description if you don't have a link."
            />
        </div>
    </section>
);

export default OpportunitySection;
